import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash';
import RadioField from '../../../Form/RadioField/RadioField';

const SHORT_LABEL_MAX_LENGTH = 40;

const columnClass = (label, isLabelColumn) => {
  const longLabel = get(label, 'length', 0) > SHORT_LABEL_MAX_LENGTH;
  return classNames({
    'pr-0 pl-4': isLabelColumn,
    'col-span-4': !longLabel && isLabelColumn,
    'col-span-8': !longLabel && !isLabelColumn,
    'col-span-6': longLabel,
  });
};

const ConsentTypeChoice = ({
  children,
  label,
  onSelect,
  selectedType,
  type,
  dropzone = null,
}) => {
  const isSelected = type === selectedType;

  const onSelectHandler = () => {
    onSelect(type);
  };

  return (
    <div className="pr-0">
      <div className="grid grid-flow-col -mx-4 items-center">
        <div className={columnClass(label, true)}>
          <RadioField
            id={type}
            name={type}
            value={isSelected ? type : ''}
            onChange={onSelectHandler}
            options={[{ label, value: type }]}
            checked={isSelected}
          />
        </div>
        {isSelected ? (
          <div className={columnClass(label, false)}>
            <div data-testid="children-content">
              {children}
            </div>
          </div>
        ) : null}
      </div>
      {isSelected && dropzone ? (
        <div className="sm:w-full" data-testid="dropzone-content">
          {dropzone}
        </div>
      ) : null}
    </div>
  );
};

ConsentTypeChoice.propTypes = {
  /** Children content shown on the right side of the radio field */
  children: PropTypes.node.isRequired,
  /** Represents the dropzone file transfer if added */
  dropzone: PropTypes.any,
  /** Label of the RadioField */
  label: PropTypes.node.isRequired,
  /** Function when radio is selected */
  onSelect: PropTypes.func.isRequired,
  /** Value of what is currently selected via parent component */
  selectedType: PropTypes.string.isRequired,
  /** Value of ConsentTypeChoice component */
  type: PropTypes.string.isRequired,
};

export default ConsentTypeChoice;
